import * as React from "react";
const SvgStayCurrentPortrait = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 1.01 5.01 1v22H19V1.01zM17 19H7V5h10v14z",
  fill: "currentColor"
}));
export default SvgStayCurrentPortrait;